"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgLocation = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_LOCATION", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M10.5 5.994C10.5 7.373 9.38 8.49 8 8.49S5.5 7.373 5.5 5.994c0-1.38 1.12-2.498 2.5-2.498s2.5 1.118 2.5 2.498Zm-2 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0Z" }),
    React.createElement("path", { d: "M14 5.994A5.997 5.997 0 0 0 8 0C4.686 0 2 2.683 2 5.994c0 4.865 3.953 8.578 5.442 9.804.327.27.789.27 1.116 0C10.047 14.572 14 10.858 14 5.994Zm-2 0c0 2.321-1.17 4.37-2.519 5.942-.518.604-1.04 1.234-1.481 1.624-.441-.39-.963-1.02-1.481-1.624C5.169 10.364 4 8.316 4 5.994a3.998 3.998 0 0 1 4-3.996c2.21 0 4 1.789 4 3.996Z" }))); };
exports.default = SvgLocation;
